var YouLi = YouLi ? YouLi : {};
YouLi.CreditCardPaymentForm = YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {};
YouLi.CreditCardPaymentForm.Paypal = YouLi.CreditCardPaymentForm.Paypal ? YouLi.CreditCardPaymentForm.Paypal : {};

(function (YouLi) {
    (function (CreditCardPaymentForm) {
        (function (Paypal) {
            YouLi.CreditCardPaymentForm.Paypal.InitialisePayPal = function () {

                if ($('#paypal-button-container').length > 0) {

                    if (YouLi.CreditCardPaymentForm.PayPalButtons != null) YouLi.CreditCardPaymentForm.PayPalButtons.close();

                    // Create and initialize a PayPal payment form object
                    YouLi.CreditCardPaymentForm.PayPalButtons = paypal.Buttons({
                        createOrder(inputData, actions) {

                            YouLi.CreditCardPaymentForm.ClearErrorInModal();

                            let data = {
                                amount: $("#ChargeAmount").val(),
                                currencyCode: YouLi.CreditCardPaymentForm.Currency.Code,
                                transactionFee: YouLi.CreditCardPaymentForm.TransactionFee,
                                merchantId: YouLi.CreditCardPaymentForm.ConnectedPaymentGatewayUserId,
                                merchantName: YouLi.CreditCardPaymentForm.Name,
                                chargeLabel: $("#ChargeLabel").val(),
                                saveCard: false
                            }
                            return new Promise(function (resolve, reject) {
                                YouLi.Common.Post({
                                    url: '/paypal/CreatePayPalPayment',
                                    params: data,
                                    suppressLoading: true,
                                    errorCallback: function () {
                                        reject(new Error('An issue has occurred and we cannot proceed.  Please contact your planner for more information'));
                                    }
                                }).then(function (order) {
                                    resolve(order.id);
                                });
                            });
                        },
                        onApprove(data) {

                            if ($("#GenericPaymentFormDialog").hasClass("in")) {
                                YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                                $("#GenericPaymentFormDialog").modal("hide");
                            }
                            YouLi.CreditCardPaymentForm.PayPalButtons.close();
                            YouLi.Common.UI.ShowLoading();

                            return YouLi.CreditCardPaymentForm.MakePaymentFunction(data.orderID, "paypal")
                                .then((response) => {
                                    YouLi.Common.UI.HideLoading();
                                })
                                .catch((error) => {
                                    YouLi.Common.UI.HideLoading();
                                })

                        },
                        onCancel(data) {
                        },
                        onError(err) {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal("An issue has occurred and we cannot proceed.  Please contact your planner for more information");
                        }
                    });
                    YouLi.CreditCardPaymentForm.PayPalButtons.render('#paypal-button-container');
                }

                //if (YouLi.CreditCardPaymentForm.PayPalCardFields == null) {

                //    YouLi.CreditCardPaymentForm.PayPalCardFields = paypal.CardFields({
                //        style: {
                //            'input': {
                //                'font-size': '14px',
                //                'font-family': 'Open Sans, Arial, Helvetica, sans-serif',
                //                'line-height': '1.42857143',
                //                'padding': '10px 12px',
                //                'color': '#555'
                //            },
                //            '.invalid': {
                //                'color': '#a94442'
                //            }
                //        },
                //        createOrder() {

                //            clearErrorInModal();

                //            let data = {
                //                amount: $("#ChargeAmount").val(),
                //                currencyCode: YouLi.CreditCardPaymentForm.Currency.Code,
                //                transactionFee: YouLi.CreditCardPaymentForm.TransactionFee,
                //                merchantId: YouLi.CreditCardPaymentForm.ConnectedPaymentGatewayUserId,
                //                merchantName: YouLi.CreditCardPaymentForm.Name,
                //                chargeLabel: $("#ChargeLabel").val(),
                //                saveCard: $("#SaveCard").is(":checked")
                //            }
                //            return YouLi.Common.Post({
                //                method: "POST",
                //                headers: { "Content-Type": "application/json" },
                //                body: JSON.stringify(data),
                //            })
                //                .then((response) => response.json())
                //                .then((order) => order.id);
                //        },
                //        onApprove: function (data) {
                //            if ($("#GenericPaymentFormDialog").hasClass("in")) {
                //                YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                //                $("#GenericPaymentFormDialog").modal("hide");
                //            }

                //            YouLi.Common.UI.ShowLoading();

                //            return YouLi.CreditCardPaymentForm.MakePaymentFunction(data.orderID, "paypal")
                //                .then((response) => {
                //                    YouLi.Common.UI.HideLoading();
                //                })
                //                .catch((error) => {
                //                    YouLi.Common.UI.HideLoading();
                //                })
                //        },
                //        onCancel(data) {
                //        },
                //        onError(err) {
                //            showErrorInModal("An issue has occurred and we cannot proceed.  Please contact your planner for more information");
                //            YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                //        },
                //    });

                //    if (YouLi.CreditCardPaymentForm.PayPalCardFields.isEligible()) {
                //        payPalNameField = YouLi.CreditCardPaymentForm.PayPalCardFields.NameField();
                //        payPalNameField.render("#card-name-field-container");

                //        payPalNumberField = YouLi.CreditCardPaymentForm.PayPalCardFields.NumberField();
                //        payPalNumberField.render("#card-number-field-container");

                //        payPalExpiryField = YouLi.CreditCardPaymentForm.PayPalCardFields.ExpiryField();
                //        payPalExpiryField.render("#card-expiry-field-container");

                //        payPalCVVField = YouLi.CreditCardPaymentForm.PayPalCardFields.CVVField();
                //        payPalCVVField.render("#card-cvv-field-container");
                //    } else {
                //        // Handle the workflow when credit and debit cards are not available
                //        console.error("Credit and debit cards are not available");
                //        $("#SaveCardOption").hide();
                //        $("#AutoPayEnrolOption", "#GenericPaymentFormDialog").hide();
                //    }
                //    const submitButton = document.getElementById("p-creditcard");
                //    submitButton.addEventListener("click", () => {

                //        // Validate the form before anything else
                //        let $form = $('#GenericPaymentForm');
                //        $form.validateBootstrap();
                //        if (!$form.valid()) {
                //            console.log("Invalid form");
                //            showErrorInModal("Please review form and try again");
                //            YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                //            return;
                //        }

                //        YouLi.CreditCardPaymentForm.PayPalCardFields.submit()
                //            .then(() => { })
                //            .catch((error) => {
                //                showErrorInModal("Invalid card details, please review and try again");
                //                YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                //            });
                //    });

                //    $("#SaveCard.planner-save-card").off("change");
                //    $("#SaveCard.planner-save-card").on("change", function () {
                //        $("#SaveCardPlannerDetails").toggleClass("hidden", !$(this).is(":checked"));
                //    });

                //    // initialise tooltip for Save Card manually (if needed)
                //    $('#SaveCardPlannerDetails [data-toggle="tooltip"]').tooltip({
                //        trigger: "hover focus",
                //        container: "body"
                //    });

                //} // end PayPalCardFields init

            };
        }(YouLi.CreditCardPaymentForm.Paypal ? YouLi.CreditCardPaymentForm.Paypal : {}));
    }(YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {}));
}(YouLi ? YouLi : {}));